import "../../../../App.css";
import { Backdrop, Container, createTheme } from "@material-ui/core";
import { connect, Provider } from "react-redux";
import _ from "lodash";
import { SnackbarProvider } from "notistack";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { ThemeProvider } from "@mui/styles";

import Box from "@mui/material/Box";
import Spinner from "../../../../common/components/SpinnerCustomized";
import PuiMainTitle  from "@portnet/ui/dist/components/typography/PuiMainTitle"
import NotListedLocationIcon from '@mui/icons-material/NotListedLocation';
import store from "../../../../common/state/Store";
import {convertHex, extractUrlParams} from "../../../../common/utils/Utils";
import NtnResultForm from "./NtnResultForm";
import SearchForm from "./NtnSearchForm";
export const theme = createTheme({
    palette: {
        primary: {
            main: "#232f66",
        },
        secondary: {
            main: "#ffffff",
        },
        accent1: {
            main: "#484848",
        },
        accent2: {
            main: "#7e7e7e",
        },
        accent3: {
            main: "#f3f3f3",
        },
        error: {
            main: "#F50909FF",
        },
        success: {
            main: "#07851CFF",
        },
    },
});

const buildBackDropLayer = (children) => {
    return (
        <Backdrop
            style={{
                flex: 1,
                zIndex: 200,
                color: "white",
                backgroundColor: convertHex("#232f66", 70),
            }}
            open={true}
        >
            {children}
        </Backdrop>
    );
};

function GuApp(props) {
    const unauthorizedPort = _.pickBy(props.PortsReducer, isUnautorized);
    const unauthorizedShipment = _.pickBy(props.ShipmentReducer, isUnautorized);

    function showMessage(message) {
        if(message.startsWith('java.net.'))
            return "Service momentanément indisponible, veuillez réessayer ultérieurement"
        else
            return message;
    }

    return (
        <Provider store={store}>
            <ThemeProvider >
                <SnackbarProvider maxSnack={3}>
                    {(!_.isEmpty(unauthorizedPort) || !_.isEmpty(unauthorizedShipment)) &&
                        buildBackDropLayer(
                            <Box>
                                <Typography
                                    variant="h5"
                                    component="h5"
                                    style={{
                                        textAlign: "center" + "",
                                    }}
                                >
                                    Votre session a expiré. Veuillez vous reconnecter au G.U
                                </Typography>
                            </Box>
                        )}
                    <div style={{ flex: 1 }}>
                        {props.loadingProps?.isLoading ? <Spinner /> : <></>}

                        <Container
                            style={{
                                justifyContent: "center",
                                alignItems: "center",
                                width: "99%",
                            }}
                        >
                            <PuiMainTitle
                                icon={<NotListedLocationIcon/>}
                                title="Track & Trace"

                            />


                            {/*<Grid item xs={12} md={3}>
                  <Paper style={{ height: "75", width: "50" }}>
                    <Container
                      style={{
                        border: "2px solid #404f92",
                        backgroundColor: theme.palette.accent3.main,
                        padding: "20px",
                        marginTop: "30px",
                        marginBottom: "20px",
                        height: "155px",
                      }}
                    >
                      <NtnOperateurSolde
                        solde={props.solde.data?.solde}
                      ></NtnOperateurSolde>
                    </Container>
                  </Paper>
                </Grid>*/}


                            {props.shipments.info && (
                                <Typography
                                    variant="h6"
                                    color="orange"
                                    style={{
                                        border: "1px solid orange",
                                        fontWeight: "bold",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        backgroundColor: "#F8E1D2FF",
                                        margin: "10px 0",
                                    }}
                                >
                                    <i className="fa fa-exclamation-triangle"></i>{" "}
                                    {props.shipments.info}
                                </Typography>
                            )}
                            {props.shipmentsRefresh.error?.status == 400 && (
                                <Typography
                                    variant="h6"
                                    color="error"
                                    style={{
                                        border: "1px solid red",
                                        fontWeight: "bold",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        backgroundColor: "#ffd3d3",
                                        margin: "10px 0",
                                    }}
                                >
                                    <i class="fa fa-exclamation-circle"></i>{" "}
                                    {props.shipmentsRefresh.error?.message}
                                </Typography>
                            )}
                            {props.shipments.error?.status == 400 && (
                                <Typography
                                    variant="h6"
                                    color="error"
                                    style={{
                                        border: "1px solid red",
                                        fontWeight: "bold",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        backgroundColor: "#ffd3d3",
                                        margin: "10px 0",
                                    }}
                                >
                                    <i class="fa fa-exclamation-circle"></i>{" "}
                                    {props.shipmentsRefresh.error?.message}
                                    {props.shipments.error?.message}
                                </Typography>
                            )}

                            {props.shipmentsRefresh.error?.status == 500 && (
                                <Typography
                                    variant="h6"
                                    color="error"
                                    style={{
                                        border: "1px solid red",
                                        fontWeight: "bold",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        backgroundColor: "#ffd3d3",
                                        margin: "10px 0",
                                    }}
                                >
                                    <i class="fa fa-exclamation-circle"></i>{" "}
                                    {showMessage(props.shipmentsRefresh.error?.message)}
                                </Typography>
                            )}
                            {props.shipments.error?.status == 500 && (
                                <Typography
                                    variant="h6"
                                    color="error"
                                    style={{
                                        border: "1px solid red",
                                        fontWeight: "bold",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        backgroundColor: "#ffd3d3",
                                        margin: "10px 0",
                                    }}
                                >
                                    <i class="fa fa-exclamation-circle"></i>
                                    {" "}
                                    { showMessage(props.shipments.error?.message)}
                                </Typography>
                            )}
                            {props.blockScreen && (
                                <Typography
                                    variant="h6"
                                    color="error"
                                    style={{
                                        border: "1px solid red",
                                        fontWeight: "bold",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        backgroundColor: "#ffd3d3",
                                        margin: "10px 0",
                                    }}
                                >
                                    <i class="fa fa-exclamation-circle"></i> Veuillez vous
                                    reconnecter au Guichet Unique
                                </Typography>
                            )}
                            <SearchForm
                                ports={props.portList.data}
                                params={extractUrlParams(window.location.href)}
                            ></SearchForm>

                            <NtnResultForm
                                theme={theme}
                                shipments={
                                    _.isEmpty(props.shipments.data)
                                        ? props.shipmentsByUser.data.list
                                        : props.shipments.data.list
                                }
                            ></NtnResultForm>
                        </Container>
                    </div>
                </SnackbarProvider>

            </ThemeProvider>
        </Provider>
    );
}

function isUnautorized(value) {
    return value?.status === 401;
}
const mapStateToProps = (state) => {
    let loadingProps;
    let reducerHasLoading = _.pickBy(state, { isLoading: true });

    if (reducerHasLoading) {
        const target = _.keys(reducerHasLoading)[0];
        let nextProps = reducerHasLoading[target];
        if (target) {
            loadingProps = { ...nextProps };
        }
    }
    return {
        ...state,
        shipmentsByUser: state.ShipmentByUserReducer,
        shipments: state.ShipmentReducer,
        shipmentsRefresh: state.ShipmentRefreshReducer,
        portList: state.PortsReducer,
        solde: state.SoldeReducer,
        loadingProps: loadingProps,
    };
};

export default connect(mapStateToProps)(GuApp);
